import QuillLocalStorage from 'core/utils/localStorageClient';

import getConfig from 'next/config';

const LocalStorage = QuillLocalStorage.getInstance();
const { publicRuntimeConfig } = getConfig();

export const PLATFORM = {
  ANDROID: /Android/i,
  CHROME: /CHROME/i,
  EDGE: /EDG/i,
  FIREFOX: /FIREFOX/i,
  IOS: /iPhone|iPad|iPod/i,
  IPHONE: /iPhone|iPod/i,
  TABLET: /ipad|tablet/i,
  OPERA: /OPR/i,
  OPERA_MINI: /Opera Mini/i,
  SAFARI: /SAFARI/i,
  IE: /Trident/i,
  MAC: /Mac\s*OS/i,
};

export const DEVICE_VIEWPORTS = {
  xs: '(max-width: 599.99px)',
  sm: '(min-width: 576px) and (max-width: 767.98px)',
  md: '(min-width: 768px) and (max-width: 991.98px)',
  lg: '(min-width: 992px) and (max-width: 1199.98px)',
  xl: '(min-width: 1200px)',
};

export const APP_SETTINGS: any = {
  showToolTips: LocalStorage.get('showToolTips', 'true') === 'true',
  // showLegend: LocalStorage.get('showLegend', 'true') === 'true',
  showScrollbar: LocalStorage.get('showScrollbar', 'true') === 'true',
  REGION: LocalStorage.get('REGION') || 'us',
  allowFeedback: LocalStorage.get('allowFeedback', 'true') === 'true',
  BOT_VERIFY_THRESH: 0.5,
  INIT_WINDOW_HEIGHT: 0,
};
// export const APP_SETTINGS = {
//   showToolTips: true,
//   showLegend: true,
//   REGION: 'us',
//   allowFeedback: true,
//   BOT_VERIFY_THRESH: 0.5,
// };

export const GLOBAL = {
  CURRENT_CHAR_LIMIT: 500, // used to store updated char limit for user
  SUMMARIZER_CHAR_LIMIT: 2500,
};

export const CHAR_LIMITS = Object.freeze({
  PARAPHRASER_WORD_LIMIT_GUEST: 125,
  PARAPHRASER_WORD_LIMIT_MEMBER: 125,
  PARAPHRASER_WORD_LIMIT_PREMIUM: -1,
  SUMMARIZER_WORD_LIMIT_GUEST: 600,
  SUMMARIZER_WORD_LIMIT_MEMBER: 1200,
  SUMMARIZER_WORD_LIMIT_PREMIUM: 6000,
  EXTENSION_PLAYGROUND_CHAR_LIMIT: 400,
  GRAMMAR_CHECKER_WORD_LIMIT: 20000,
});

export const modeSequenceMap = [2, 0, 9, 10, 6, 8, 7];

export const Dims = Object.freeze({
  header: 63,
  secondHeader: 40,
  quillBoxesInVh: 35,
  quillBoxesInVhForPremium: 35,
  quillBoxesOffsetInPx: 0,
  footer: 54,
  summaryBoxesInVh: 60,
});

export const WriterDim = Object.freeze({
  maxWidth: 1000,
  suggWidthDesk: 500,
  suggWidthMobile: 250,
});

export const extensionLinks = {
  chrome: publicRuntimeConfig.CHROME_EXTENSION_URL,
  docs: 'https://workspace.google.com/marketplace/app/quillbot_paraphrasing_and_summarizing_to/305988918037',
  word: '/word',
};

export const IndexedDb: IndexedDbinterface = {
  storeName: 'qbStore',
  collections: {
    reportedWords: 'reportedWords',
    reportedSentences: 'reportedSentences',
    definitions: 'definitions',
    paraphraseHistory: 'paraphraseHistory',
  },
};

export const acceptedFormats = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const patterns = {
  phoneNumberRegex: /^[\s()+-]*([0-9][\s()+-]*){10,15}$/,
  nameRegex: /^([a-zA-Z .'-]){2,30}$/,
  webUrlRegex: /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/,
  validWordRegex: /[a-z,0-9]/i,
};
interface IndexedDbinterface {
  storeName: string;
  collections: {
    [key: string]: string;
  };
}

// campaign taxonomy: - LOCATION - SUBLOCATION (opt) - COMPONENT
interface UtmCampaignForExtension {
  [key: string]: string;
}
export const utmCampaignForExtension: UtmCampaignForExtension = {
  bannerGC: 'gc_banner',
  bannerSMZR: 'smzr_banner',
  bannerPPHR: 'pphr_banner',
  topControlBarGC: 'gc_header_btn',
  topControlBarPPHR: 'pphr_header_btn',
  exitSurvey: 'uninstall-survey_btn',
  welcomePage: 'welcome_btn',
  header: 'nav_ext-dd',
  extensionSection: 'pphr-feat-int_btn',
  sideNavbar: 'side_navbar-link',
  paymentSuccessPage: 'payment_success_page',
  modalGC: 'gc_extension_upsell_modal',
  modalPPHR: 'pphr_extension_upsell_modal',
};

export const ABTestNames = {};
